import { Autorenew } from '@material-ui/icons'
import React, { useState } from 'react'
import {
  useShowContext,
  useRefresh,
  sanitizeFetchType,
  useNotify,
  useMutation,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { SetStandbyModeDialog } from '../DoorDialogs'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { StanbyMode } from '../../../../core/enum/StanbyMode'
import doorsProvider from '../../../../core/devices/doors/doors.provider'
import { DoorDto } from '../../../../core/dto/device/doors/door.dto'
import { DateTime } from '../../../../core/common/date-time'

export const DoorStandbyModeButton = ({ ...props }) => {
  const { asRecurringJob, ...rest } = props
  const { loading, record: door } = useShowContext<DoorDto>()
  const notify = useNotify()
  const [standbyModeDialogOpen, setStandbyModeDialogOpen] = useState(false)
  const [standbyMode, setStandbyMode] = useState<StanbyMode | undefined>(
    door?.stanbyMode || undefined,
  )
  const hasAuthority = useHasAuthority()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  const handleSetStandbyModeDialog = () => {
    setStandbyModeDialogOpen(true)
  }

  const handleStandbyMode = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => {
    if (!asRecurringJob)
      await mutate(
        {
          type: sanitizeFetchType('setStandbyMode'),
          resource: ResourceName.DOORS,
          payload: {
            doorId: door?.id,
            stanbyMode: standbyMode,
          },
        },
        {
          returnPromise: true,
          onFailure: (err) => notify(err?.message, 'error'),
        },
      )
    else
      await doorsProvider.setStandbyMode(ResourceName.DOORS, {
        doorId: door?.id as number,
        stanbyMode: standbyMode as StanbyMode,
        recurringJobName,
        cronExpression,
        scheduledAt,
      })
    refresh()
  }

  return (
    <>
      <SetStandbyModeDialog
        open={standbyModeDialogOpen}
        close={() => setStandbyModeDialogOpen(false)}
        standbyMode={standbyMode}
        setStandbyMode={setStandbyMode}
        handleStandbyMode={handleStandbyMode}
        asRecurringJob={asRecurringJob}
      />
      <Button
        size="small"
        variant="contained"
        color="primary"
        label={!asRecurringJob ? 'resources.doors.actions.setStandbyMode' : ''}
        useSmallVersionBreakpoint={false}
        onClick={handleSetStandbyModeDialog}
        disabled={
          !hasAuthority(Authority.DOORS_SET_STANDBY) ||
          loading ||
          mutationLoading
        }
        {...rest}
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    </>
  )
}
